import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import FolderIcon from '@material-ui/icons/Folder';
import HomeIcon from '@material-ui/icons/Home';

// Agrupa las carpetas por su parent_id ('root' para las raíces) y ordena por nombre.
const buildChildrenMap = folders => {
  const map = {};
  (folders || []).forEach(f => {
    const key = f.parent_id == null ? 'root' : String(Number(f.parent_id));
    if (!map[key]) map[key] = [];
    map[key].push(f);
  });
  Object.keys(map).forEach(k => map[k].sort((a, b) => (a.name || '').localeCompare(b.name || '')));
  return map;
};

// Árbol de carpetas con sangría para elegir un destino.
// props: folders (lista plana), selectedId (id seleccionado | null para raíz | undefined para nada),
//        onSelect(folderOrRoot), excludeIds (Set de ids a OCULTAR con su subárbol),
//        disabledIds (Set de ids a mostrar pero NO seleccionables, dejando visibles sus hijos), includeRoot (bool).
const FolderTreeSelect = ({ folders, selectedId, onSelect, excludeIds, disabledIds, includeRoot }) => {
  const childrenMap = buildChildrenMap(folders);
  const excluded = excludeIds || new Set();
  const disabled = disabledIds || new Set();

  const renderNodes = (parentKey, depth) => {
    const nodes = childrenMap[parentKey] || [];
    return nodes
      .filter(f => !excluded.has(Number(f.id)))
      .map(f => {
        const isDisabled = disabled.has(Number(f.id));
        return (
          <React.Fragment key={f.id}>
            <ListItem
              button
              disabled={isDisabled}
              selected={selectedId !== null && selectedId !== undefined && Number(selectedId) === Number(f.id)}
              onClick={isDisabled ? undefined : () => onSelect(f)}
              style={{ paddingLeft: 16 + depth * 22 }}>
              <ListItemIcon style={{ minWidth: 34 }}>
                <FolderIcon style={{ color: '#ffb300' }} />
              </ListItemIcon>
              <ListItemText primary={f.name} />
            </ListItem>
            {renderNodes(String(Number(f.id)), depth + 1)}
          </React.Fragment>
        );
      });
  };

  const tree = renderNodes('root', 0);

  return (
    <List dense>
      {includeRoot ? (
        <ListItem button selected={selectedId === null} onClick={() => onSelect({ id: null, name: 'Raíz' })} style={{ paddingLeft: 16 }}>
          <ListItemIcon style={{ minWidth: 34 }}>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText primary="Raíz (sin carpeta padre)" />
        </ListItem>
      ) : null}
      {tree.length === 0 && !includeRoot ? (
        <Typography color="textSecondary" style={{ padding: 16 }}>
          No hay carpetas disponibles como destino.
        </Typography>
      ) : (
        tree
      )}
    </List>
  );
};

export default FolderTreeSelect;
